import Suspense from "components/shared/Suspense";
import { lazy } from "react";
import { Capacitor } from "@capacitor/core";
import useMount from "hooks/useMount";

const MobileManager = lazy(() => import("./MobileManager"));

export default function MobileManagerWrapper() {
  const isNative = Capacitor.isNativePlatform();
  const mounted = useMount();

  if (!mounted || !isNative) {
    return false;
  }

  return (
    <Suspense>
      <MobileManager />
    </Suspense>
  );
}
